/**
 * @author Srinivas
 * @copyright Whyable technologies. All rights reserved.
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

export class FileValidationErrors {
  public static invalidSize = 'INVALID_SIZE';
  public static invalidType = 'INVALID_TYPE';
  public static invalidFormat = 'INVALID_FORMAT';
  public static sizeLimitInvalidExceeded = 'SIZE_LIMIT_INVALID_EXCEEDED';
}


@Injectable({
  providedIn: 'root'
})
export class UploaderService {

  constructor(protected http: HttpClient) {
  }

  /**
   * Check file format
   * If formats is undefined it will return true
   * param file
   * param formats
   */
  private static checkFormat(file: File, formats: string[]): boolean {
    return formats ? formats.indexOf(file.name.split('.').pop()) > -1 : true;
  }

  /**
   * Check file type
   * If types is undefined it will return true
   * param file
   * param types
   */
  private static checkType(file: File, types: string[]): boolean {
    return types ? types.indexOf(file.type.split('/').shift()) > -1 : true;
  }

  /**
   * Check file size
   * If size is undefined it will return true
   * here file size is in bytes
   * param file
   * param size
   */
  private static checkSize(file: File, size: number): boolean {
    return size ? file.size < size : true;
  }

  /**
   * Validate a file with certain configurations
   */
  public validateFile(file: File, options: { maxSize: number; type: string[]; format: string[] }): Promise<File> {
    return Promise.resolve(file)
      .then((fileObj) => {
        if (UploaderService.checkFormat(fileObj, options.format)) {
          return fileObj;
        } else {
          throw FileValidationErrors.invalidFormat;
        }
      })
      .then((fileObj) => {
        if (UploaderService.checkSize(fileObj, options.maxSize)) {
          return fileObj;
        } else {
          throw FileValidationErrors.invalidSize;
        }
      })
      .then((fileObj) => {
        if (UploaderService.checkType(fileObj, options.type)) {
          return fileObj;
        } else {
          throw FileValidationErrors.invalidType;
        }
      });
  }

  /**
   * Upload a file
   * param url
   * param upload
   */
  public uploadFile(url: string, upload: { name: string; file: File }): Observable<any> {
    const form: FormData = new FormData();
    form.append(upload.name, upload.file, upload.file.name);

    // return Promise.resolve({});
    // return Observable.create((r) => r.next({}));
    return this.http.post(url, form);
  }
}
